import { motion } from 'framer-motion';
import banner from './banner.png';
import './info-block.scss';
import icon1 from './ic-1.svg';
import icon2 from './ic-2.svg';
import icon3 from './ic-4.svg';
import icon4 from './ic-5.svg';

export default function InfoBlock() {
    return (
        <motion.div
            className="info-block container"
            initial="hidden"
            animate="visible"
            variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
            }}
        >
            <motion.div
                className="info-block__column"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
            >
                <h3 className="info-block__subtitle">Statistics:</h3>
                <img src={banner} alt="" />
            </motion.div>

            <motion.div
                className="info-block__column"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
            >
                <h3 className="info-block__subtitle">Trading:</h3>

                <div className="info-block__list">
                    {[icon1, icon2, icon3, icon4].map((icon, i) => (
                        <motion.div
                            key={i}
                            className="info-block__item"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3 + i * 0.15, duration: 0.4 }}
                        >
                            <img src={icon} alt="" />

                            <div className="info-block__item-text">
                                {i === 0 && <>
                                    <h5>Platform:</h5>
                                    <span>Web-based & mobile interface</span>
                                </>}
                                {i === 1 && <>
                                    <h5>Assets:</h5>
                                    <span>Cryptocurrencies, indices, commodities, stocks</span>
                                </>}
                                {i === 2 && <>
                                    <h5>Smart Signals:</h5>
                                    <span>Alerts based on key levels & news impact</span>
                                </>}
                                {i === 3 && <>
                                    <h5>Security:</h5>
                                    <span>Multi-layer verification, cold wallet storage</span>
                                </>}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </motion.div>
    );
}
